import {Component} from "react";
import "./ContactForm.css";
import fb from "../../media/fb.svg";
import tiktok from "../../media/tiktok.svg";
import insta from "../../media/insta.svg";
import {sendMessage} from "../../Helpers/Actions";

export default class ContactForm extends Component {
    render() {
        return (
            <div className="contact-form">
                <div className="gray-box">
                    <h2>¿No encuentras lo que estas buscando?</h2>
                    <div className="text">
                        Si tienes alguna duda en específico sobre algún servicio de reparación, no dudes en escribirnos al siguiente formulario o en nuestros diferentes medios de comunicación.
                    </div>
                    <div className="redes">
                        <a href="">
                            <img src={fb} alt=""/>
                        </a>
                        <a href="">
                            <img src={tiktok} alt=""/>
                        </a>
                        <a href="">
                            <img src={insta} alt=""/>
                        </a>
                    </div>
                </div>
                <div className="form">
                    <div className="form-group">
                        <input type="text" id={"client_name"} placeholder={"Nombre"}/>
                        <label htmlFor="">Nombre</label>
                    </div>
                    <div className="form-group">
                        <input type="number" id={"client_phone"} placeholder={"Teléfono"}/>
                        <label htmlFor="">Teléfono</label>
                    </div>
                    <div className="form-group">
                        <input type="email" id={"client_email"} placeholder={"Email"}/>
                        <label htmlFor="">Email</label>
                    </div>
                    <div className="form-group">
                        <textarea placeholder={"Pregunta"} id={"message"}/>
                        <label htmlFor="">Pregunta</label>
                    </div>
                    <div className="buttons">
                        <button className="blue-button" onClick={sendMessage}>Enviar</button>
                    </div>
                </div>
            </div>
        )
    }
}